import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessUserInterface } from './process-user-interface';
export { ProcessUserInterface };
import { processUserInterfaceSchema } from '@schemas/business-objects/process-user-interface';
import { ProcessUserInterfacePropertyFormArray } from './process-user-interface-property-form-group';

export class ProcessUserInterfaceFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    processUserInterfaceProperties: ProcessUserInterfacePropertyFormArray;
  };

  declare value: Partial<ProcessUserInterface>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processUserInterfaceSchema, ProcessUserInterface, data, options);
  }

  get object(): ProcessUserInterface {
    return new ProcessUserInterface(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processUserInterfaceProperties':
        return new ProcessUserInterfacePropertyFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessUserInterface[]> {
    return ProcessUserInterface.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessUserInterface | null> {
    return ProcessUserInterface.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessUserInterface> {
    return ProcessUserInterface.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessUserInterface>,
  ): Promise<ProcessUserInterface> {
    return ProcessUserInterface.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessUserInterface>,
  ): Promise<ProcessUserInterface> {
    return ProcessUserInterface.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessUserInterface.deleteById(id);
  }
}

export class ProcessUserInterfaceFormArray extends PersistedFormArray {
  declare controls: ProcessUserInterfaceFormGroup[];

  readonly entityName = 'ProcessUserInterface' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processUserInterfaceSchema, ProcessUserInterface, options);
  }

  protected override createItemGroup() {
    return new ProcessUserInterfaceFormGroup();
  }

  get array(): ProcessUserInterface[] {
    return this.controls.map(
      (group: ProcessUserInterfaceFormGroup) => group.object,
    );
  }
}

export class ProcessUserInterfacePersistedArray extends PersistedArray<ProcessUserInterface> {
  readonly entityName = 'ProcessUserInterface' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessUserInterface, options);
  }
}
